import { PageOrders as Page } from '@/components/orders/order-list/OrderList';

export default function PageOrders() {
	return (
		<div className='component-container'>
			<Page />
		</div>
	);
}
